module.exports = __webpack_public_path__ + "img/horizontal_3_5_1.692b8905.png";